// extracted by mini-css-extract-plugin
export default {"link":"styles_link__Kz-q0","titleSvg":"styles_titleSvg__UQ4nx","wordSvg":"styles_wordSvg__MzRj+","wrapper":"styles_wrapper__Y95q4"};